import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { openCustomerPortal } from '../../../utils/cn';

const CTASection = () => {
  return (
    <>
      <section className="py-16 bg-gradient-to-br from-primary to-secondary">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <div className="text-white">
            <Icon name="Headphones" size={48} className="mx-auto mb-6 text-white/80" />
            
            <h2 className="text-3xl lg:text-4xl font-jakarta font-bold mb-4">
              Ready to Get Started?
            </h2>
            
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Don't let roofing questions hold you back. Our expert team is here to guide you through 
              every step of your roofing journey with transparent pricing and transparent advice.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Button 
                variant="secondary" 
                size="lg"
                iconName="Calculator"
                iconPosition="left"
                onClick={() => openCustomerPortal()}
              >
                Get Pricing in 30 Minutes
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="border-white text-white hover:bg-white hover:text-primary"
                iconName="Phone"
                iconPosition="left"
                onClick={() => window.location.href = 'tel:+1-555-ROOF-NOW'}
              >
                Speak with Expert
              </Button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
              <div className="flex items-center justify-center space-x-2">
                <Icon name="Shield" size={16} className="text-white/80" />
                <span className="text-white/90">3-Year Warranty</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <Icon name="DollarSign" size={16} className="text-white/80" />
                <span className="text-white/90">No Hidden Fees</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <Icon name="Clock" size={16} className="text-white/80" />
                <span className="text-white/90">24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Background decoration */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"></div>
        </div>
      </section>
    </>
  );
};

export default CTASection;